import { AiNarrativeContext, AiPromptTemplateParams } from './types';

export function stripSourceRefs(html: string): string {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  tempDiv.querySelectorAll('a.ai-source-ref').forEach(node => {
    node.remove();
  });

  return tempDiv.innerHTML.replace(/\s+(?=[.,;:])/g, '').trim();
}

// Block tags become spaces, so words are not glued across paragraphs.
export function getPlainText(html: string): string {
  if (!html) return '';

  const spaced = html.replace(
    /<\/?(p|div|li|ul|ol|h[1-6]|br|blockquote|pre|tr|td|th)[^>]*>/gi,
    ' ',
  );
  const div = document.createElement('div');
  div.innerHTML = spaced;
  return div.textContent || '';
}

export function promptTemplateParams(
  context: AiNarrativeContext,
): AiPromptTemplateParams {
  return { narrative_type: context.narrativeType };
}

export function promptTemplateKey(params: AiPromptTemplateParams): string {
  return params.narrative_type;
}

export function hasPromptTemplateParams(
  params: AiPromptTemplateParams,
): boolean {
  return Boolean(params.narrative_type);
}

const PLACEHOLDER_PATTERN = /\{\{\s*(\w+)\s*\}\}|\{\s*(\w+)\s*\}/g;

// Unresolved placeholders are reported rather than sent to Bedrock as literal
// text. An empty string is a legitimate value.
export function fillTemplate(
  template: string,
  vars: Record<string, string | number>,
): string {
  const missing: string[] = [];

  const filled = template.replace(
    PLACEHOLDER_PATTERN,
    (match, doubled, single) => {
      const name = doubled || single;
      const value = vars[name];

      if (value === undefined || value === null) {
        missing.push(name);
        return match;
      }

      return String(value);
    },
  );

  if (missing.length) {
    throw new Error(
      `Prompt template has unresolved placeholders: ${Array.from(
        new Set(missing),
      ).join(', ')}`,
    );
  }

  return filled;
}
